package com.tfc.care.tfccare

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.tfc.care.tfccare.di.appModule
import com.tfc.care.tfccare.di.platformModule
import com.tfc.care.tfccare.utils.Logger
import kotlinx.browser.window
import org.koin.core.context.startKoin
import kotlin.js.js

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    // In production, set this to false
    Logger.init(debug = true)
    Logger.d("App starting...")
    val firebaseConfig = js("""{
        apiKey: "AIzaSyD-vp8YprLHTv22a4yChy-uTcZJ0h5d93Q",
        authDomain: "wltpe-404512.firebaseapp.com",
        databaseURL: "https://wltpe-404512-default-rtdb.asia-southeast1.firebasedatabase.app",
        projectId: "wltpe-404512",
        storageBucket: "wltpe-404512.firebasestorage.app",
        appId: "1:989506235187:web:5d65fc69252855c6ec6c46"
    }""")
    
    Logger.d("Firebase Request: initializeApp")
    try {
        FirebaseApp.initializeApp(firebaseConfig)
        Logger.d("Firebase Response: initializeApp - Success")
    } catch (e: Exception) {
        Logger.e("Firebase Response: initializeApp - Error: ${e.message}", e)
    }

    startKoin {
        modules(platformModule, appModule)
    }

    val params = parseUrlParams()
    val userId = params["id"]
    val password = params["pwd"]

    ComposeViewport {
        clearUrlParams()
        App(userId,password)
    }
}


fun parseUrlParams(): Map<String, String> {
    val search = window.location.search
    if (search.isEmpty()) return emptyMap()

    return search.removePrefix("?")
        .split("&")
        .mapNotNull { param ->
            val parts = param.split("=", limit = 2)
            if (parts.size == 2) parts[0] to parts[1] else null
        }
        .toMap()
}

fun clearUrlParams() {
    // Remove credentials from URL bar immediately after login
    window.history.replaceState(null, "", window.location.pathname)
}


//./gradlew :composeApp:jsBrowserDistribution